import React from "react";

import "moment/locale/fr";
import "react-app-polyfill/ie11";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import "./index.css";
import store from "./store";

import ErrorScreen from "./screens/Utils/ErrorScreen";
import LoadingScreen from "./screens/Utils/LoadingScreen";

import API from "./utils/API";
import { isLocalAPI } from "./utils/utils";
import { NavigationProvider } from "./utils/navigationProvider";

ReactDOM.render(<LoadingScreen />, document.getElementById("root"));

// TODO : Find better way to store these creds in dap-front-library
window.fileRetrieveUrl = isLocalAPI ? "http://localhost:81/files/retrieve" : window.env.API_URL + "/dap-admin/api/v1/files/retrieve";
window.fileRetrieveHeaders = {
    client_id: window.env.API_CLIENT_ID,
    client_secret: window.env.API_CLIENT_SECRET,
    Authorization: "Bearer " + localStorage.getItem("access_token"),
};

API.request({
    path: isLocalAPI ? "/constants" : "/dap-admin/api/v1/settings/constants",
})
    .then((constants) => {
        window.CONSTANTS = constants;
        ReactDOM.render(
            <Router>
                <Provider store={store}>
                    <NavigationProvider>
                        <App />
                    </NavigationProvider>
                </Provider>
            </Router>,
            document.getElementById("root")
        );
    })
    .catch((e) => {
        console.log({ e });
        ReactDOM.render(
            <ErrorScreen title="Erreur" content="Le service est indisponible, veuillez réessayer ultérieurement" />,
            document.getElementById("root")
        );
    });
